import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import OTPField from "../../../components/Form/OTPField";
import {
  FIELD_MIN_LENGTH,
  FIELD_REQUIRED,
  OTP_VERIFICATION_EMAIL_SENT,
  OTP_VERIFICATION_TITLE,
} from "../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../lib/i18next";

const OTP_BOX_ROUND = "12px";

const RegisterVerificationStep = ({
  control,
  errors,
  emailMasked = "",
  titleKey = OTP_VERIFICATION_TITLE,
  subtitleKey = OTP_VERIFICATION_EMAIL_SENT,
  hideHeader = false,
}) => {
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 3,
      }}
    >
      {!hideHeader && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
            {t(titleKey)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(subtitleKey, {
              emailMasked,
            })}
          </Typography>
        </Box>
      )}

      <OTPField
        fullWidth
        name="otpCode"
        variant="filled"
        color="primary"
        control={control}
        otpBoxSx={{
          width: 52,
          height: 60,
          borderRadius: OTP_BOX_ROUND,
        }}
        otpInputSx={{
          lineHeight: "60px",
          fontSize: 22,
        }}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
          validate: (value) => {
            if (value.length >= 1 && value.length <= 5) {
              return t(FIELD_MIN_LENGTH, {
                value: 6,
              });
            }
          },
        }}
        errors={errors}
      />
    </Box>
  );
};

export default RegisterVerificationStep;
